module.exports = __webpack_public_path__ + "img/purple-bg.5d3061b1.jpg";